import {
    getAccountList,
    getUserAccountList,
    handleKeyDown,
    makePaymentApi,
    uploadFiles,
} from "_services";
import {
    CityDropdownForTrip,
    CommonCanvas,
    CommonDatePicker,
    CommonInput,
    CustomSelect,
    SkeletonInput,
} from "components";
import { UserContext } from "context";
import { errorSchema, utils } from "helper";
import useFetchDropdowns from "hooks/useFetchDropdowns";
import AddAccountingAccount from "modals/AddAccountingAccount";
import AddBankAccount from "modals/AddBankAccount";
import BankListCanvas from "modals/BankListCanvas";
import PayNowAccountNotifyModal from "modals/PayNowAccountNotifyModal";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import StorageService from "utils/StorageServices/StorageServices";


const MakePaymentForExpenseModal = ({
    detailsProps,
    accountListVender,
    callBackApiCall,
    closeModal,
    setIsOpenPayNow,
    ...props
}) => {

    const initiFrom = {
        company_id: StorageService.getCompanyId(),
        service_id: "",
        category: "",
        sub_category: "",
        due_amount: "",
        date: new Date(),
        account_category: "",
        account_sub_category: "",
        account_id: "",
        vendor_bank_account: "",
        file: [],
        service_id: "",
        vendor_type: "",
        vendor_id: "",
        eb_payment_mode: "",
        eb_account_id: ""
    };
    const {
        masterData,
        bankDetails,
        setBankDetails,
    } = useContext(UserContext);
    const [form, setForm] = useState(initiFrom);
    const [formError, setFormError] = useState("");
    const [freigtAccount, setFreigtAccount] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const [isCheck, setIsCheck] = useState(bankDetails ? true : false);
    const [bankAccountList, setBankAccountList] = useState([]);
    const [isLoadding, setIsLoadding] = useState(false);
    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [accountType, setAccountType] = useState();
    const [accountLoading, setAccountLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [bankRequiredDetails, setBankRequiredDetails] = useState({})
    const [canvasOpen, setCanvasOpen] = useState(false);
    const [showAddBank, setShowAddBank] = useState(false);
    const [venderDetails, setVenderDetails] = useState({
        vender_type: 0,
        vender_id: ''

    })
    const [accountAddShow, setAccountAddShow] = useState(false);
    const [easeBuzzId, setEaseBuzzId] = useState("")
    const [payNowAccountCreate, setpayNowAccountCreate] = useState(false);
    const {
        fetchDriverForVoucher
    } = useFetchDropdowns();

    useEffect(() => {
        if (masterData) {
            getMasterFreight();
        }
    }, [masterData]);



    useEffect(() => {
        let value = false;

        // 1️⃣ bankRequiredDetails rule
        if (bankRequiredDetails?.vendor_account === true && form?.account_sub_category == 2 && form?.vendor_id?._id) {
            value = true;
        }

        // 2️⃣ form/account rules
        if (form?.account_id === "") {
            value = false;
        }

        if (form?.account_sub_category == 27 || form?.account_sub_category == 28) {
            value = true;
        }

        // if (form?.account_sub_category == 27) {
        //     value = true;
        // }

        // Final update in one place:
        setIsCheck(value);

    }, [
        bankRequiredDetails,
        form?.account_sub_category,
        form?.account_id,
    ]);


    useEffect(() => {
        if (accountType) {
            setForm({ ...form, account_id: "", vendor_bank_account: "" });
            setBankDetails("");

        }
    }, [accountType]);

    const getVenderAccountListHandler = async (venderDetailsPara) => {
        try {
            const res = await getAccountList({
                company_id: StorageService?.getCompanyId(),
                vendor_type: venderDetailsPara?.vender_type,
                vendor_id: venderDetailsPara?.vender_id,
            });

            if (res?.responseCode === 200) {
                const details = res?.data?.bank_account?.map((item) => {

                    return {
                        ...item,
                        label: item?.bank_name || item?.account_name || item?.upi_id,
                        value: item?._id,
                    };
                });
                setBankAccountList(details);
            } else {
            }
        } catch (error) {
        }
    };

    const getMasterFreight = async () => {
        try {
            const details = masterData?.account_category?.sub_category?.map(
                (item) => {
                    return {
                        label: item?.name,
                        value: item?.id,
                        category_id: masterData?.account_category?.id,
                    };
                }
            );

            const detailsAccount =
                masterData?.account_category?.sub_category
                    ?.filter((k) => k.id !== 15 && k.id !== 26 && k.id !== 27)
                    ?.map((item) => {
                        return {
                            label: item?.name,
                            value: item?.id,
                            category_id: masterData?.account_category?.id,
                        };
                    })
            // ?.concat({
            //     label: "To Pay",
            //     value: 15,
            //     category_id: masterData?.account_category?.id,
            // });

            const order = [15, 3, 2, 27, 14, 28];
            const sortedData = detailsAccount.sort(
                (a, b) => order.indexOf(a.value) - order.indexOf(b.value)
            );

            if (sortedData && details) {
                setForm({
                    ...form,
                    category: detailsProps?.type,
                    sub_category: detailsProps?.sub_type,
                    account_category: detailsProps?.payment_mode?.account_category,
                    account_sub_category:
                        detailsProps?.payment_mode?.account_sub_category,
                    account_id: detailsProps?.payment_mode?.account?._id,
                    amount: detailsProps?.total_amount,
                    txn_date: new Date(detailsProps?.date),
                    description: detailsProps?.description,
                    file: detailsProps?.file,
                    // vendor_bank_account: detailsProps?.vendor_bank_account!=null?{
                    //   label: detailsProps?.vendor_bank_account?.name?detailsProps?.vendor_bank_account?.name:detailsProps?.vendor_bank_account?.upi_id,
                    //   value: detailsProps?.vendor_bank_account?._id,
                    // }:"",
                    vendor_bank_account: detailsProps?.vendor_bank_account?._id
                        || "",
                    transaction_no: detailsProps?.transaction_no,
                    vendor_id:{}
                });
                setIsCheck(detailsProps?.vendor_bank_account?._id ? true : false);
                setFreigtAccount(sortedData);

            }
        } catch { }
    };

    const getAccountListHandler = async (newParam = "") => {
        setAccountLoading(true);
        try {
            const res = await getUserAccountList({
                company_id: StorageService?.getCompanyId(),
                category_id: parseInt(form?.account_category ?? 1),
                sub_category_id: parseInt(form?.account_sub_category),
            });

            if (res?.responseCode === 200) {
                setAccountLoading(false);
                const details = res?.data?.account_list?.map((item) => {
                    return {
                        ...item,
                        label: item?.name,
                        value: item?._id,
                    };
                });
                if (details?.length > 0) {

                    const lastItem = details[details.length - 1];
                    const selectedAccount = newParam === "new"
                        ? (lastItem?.value ?? "")
                        : (details?.[0]?.value ?? "");

                    setAccountList(details);

                    // ✅ Functional update use karo
                    setForm(prevForm => ({
                        ...prevForm,
                        account_id: selectedAccount
                    }));

                    if (selectedAccount) {
                        setFormError((f) => ({ ...f, account_id: "" }))
                    }

                    setBankRequiredDetails(newParam == "new" ? lastItem : details[0]);
                    if (form?.account_sub_category == 28) {
                        setEaseBuzzId(details[0]?.eb_account_id)

                    } else {
                        setEaseBuzzId("")
                    }

                } else {
                    if (details.length == 0 && form?.account_sub_category == 28) {
                        setpayNowAccountCreate(true)
                    }

                    setForm((prev) => ({
                        ...prev,
                        account_id: "", // fallback or reset
                    }));
                }

            } else {
                setAccountLoading(false);
                setAccountList([]);
            }
        } catch (error) {
            setAccountList([]);
        }
    };

    const handleOnChange = async (name, value) => {
        const stateObj = {
            ...form,  // ✅ Pehle existing form spread karo
            [name]: value,
        };
        setForm(stateObj);

        if (!!formError) {
            const validationResult = await utils.checkFormError(
                {
                    ...stateObj,
                    isCheck: isCheck,

                },
                errorSchema.addMakeAmountExpenseSchema
            );
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const onSubmitFreight = async () => {
        const validationResult = await utils.checkFormError(
            { ...form },
            errorSchema.addMakeAmountExpenseSchema
        );

        const payload = {
            company_id: form?.company_id,
            voucher_id: detailsProps?._id,
            date: utils.convertToISO(form?.txn_date, true),
            description: form?.description,
            expense_category: form?.expense_category,
            account_category: form?.account_category
                ? parseInt(form?.account_category)
                : "",
            account_sub_category: form?.account_sub_category
                ? parseInt(form?.account_sub_category)
                : "",
            account_id: form?.account_id ? form?.account_id : "",
            vendor_bank_account: form?.vendor_bank_account

        };

        if (validationResult == true) {

            if (form?.account_category == 1 && form?.account_sub_category == 28) {
                setIsOpenPayNow(true)
            } else {
                try {
                    setIsLoadding(true);
                    const res = await makePaymentApi(payload);

                    if (res?.responseCode == 200) {
                        setIsLoadding(false);
                        callBackApiCall(true);
                        setBankDetails('')
                        closeModal();
                    } else {
                        setIsLoadding(false);
                    }
                } catch (error) {
                    setIsLoadding(false);
                }
            }


        } else {
            setFormError(validationResult);
        }
    };

    const modifyProps = {
        ...props,
        closeModal: closeModal,
        onSubmit: onSubmitFreight,
        isLoadding: isLoadding,
        disabled: isLoadding,
        isLoadingSave: isLoadingSave,
    };


    const handleFileChange = async (e) => {
        const file = e?.target?.files[0];
        const allowedImageTypes = ["image/gif", "image/jpeg", "image/png"];
        const allowedPdfType = "application/pdf";

        if (file) {
            if (allowedImageTypes.includes(file.type)) {
                setLoading(true);
                try {
                    const formData = new FormData();
                    formData.append("file", file);
                    const res = await uploadFiles(formData);
                    if (res?.responseCode === 200) {
                        const fileArray = [
                            ...(form?.file || []),
                            {
                                filename: res?.data?.filename,
                                path: res?.data?.path,
                            },
                        ];
                        handleOnChange("file", fileArray);
                        setLoading(false);
                        toast.success("Image added successfully.");
                    }
                } catch (error) {
                    setLoading(false);
                    toast.error("Failed to upload image. Please try again.");
                }
            } else if (file.type === allowedPdfType) {
                setLoading(true);
                try {
                    const formData = new FormData();
                    formData.append("file", file);
                    const res = await uploadFiles(formData);
                    if (res?.responseCode === 200) {
                        const fileArray = [
                            ...(form?.file || []),
                            {
                                filename: res?.data?.filename,
                                path: res?.data?.path,
                            },
                        ];
                        handleOnChange("file", fileArray);
                        setLoading(false);
                        toast.success("PDF added successfully.");
                    }
                } catch (error) {
                    setLoading(false);
                    toast.error("Failed to upload PDF. Please try again.");
                }
            } else {
                toast.error("Invalid file type. Please choose a JPEG, PNG, or PDF file.");
            }
        } else {
            toast.error("No file selected.");
        }
    };

    const documentRemove = (index) => {
        const newFromIput = [...form?.file];

        newFromIput.splice(index, 1);

        setForm({ ...form, file: newFromIput });
    };

    const filterList = (claimAccount) => {
        return claimAccount?.filter((i) => i.value != 10);
    };

    const callBackAddAccount = () => {
        setCanvasOpen(true);
        getVenderAccountListHandler(venderDetails);
    }

    const callBackAccount = () => {
        getAccountListHandler("new")
    }

    const accountClose = () => {
        setShowAddBank(false);
        setCanvasOpen(true);
    };

    const addAccountHandle = () => {
        setAccountAddShow(true);
    };


    let bankListProps = {
        setCanvasOpen: setCanvasOpen,
        canvasOpen: canvasOpen,
        setShowAddBank: setShowAddBank,
        accountList: bankAccountList,
        venderDetails: venderDetails
    };


    let firstAddBank = {
        isOpen: showAddBank,
        closeModal: accountClose,
        headerPart: false,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Add Bank Account",
        submitTitle: "Continue",
        callBackAddAccount: callBackAddAccount,
        venderDetails: venderDetails
    };

    let AddTransactionAccountModal = {
        isOpen: accountAddShow,
        closeModal: (e) => setAccountAddShow(false),
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Add Account ",
        footerPart: true,
        submitTitle: "Add Account",
        callBackAddAccount: callBackAccount
    }

    let payNowAccountProps = {
        isOpen: payNowAccountCreate,
        closeModal: (e) => {
            setpayNowAccountCreate(false)
            setAccountType(3);
            setForm((pre) => ({ ...pre, account_sub_category: 3 }));
        },
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Pay Now ",
        // headerPart: true,
        footerPart: true,
        submitTitle: "Create Account",

    }


    console.log("detailsProps", detailsProps)

    return (
        <div>
            <CommonCanvas {...modifyProps}>
                <div className="offcanvas-body">
                    <div className="_lrCl_offCavBody __otr_expCanva">
                        <div className="_othrExp_recBx">
                            <div className="_clPay_flex">
                                <div className="singleDiv">
                                    <CommonDatePicker
                                        name="date"
                                        label="Transaction Date"
                                        startDate={form?.txn_date}
                                        setStartDate={(data) => {
                                            handleOnChange("txn_date", data);
                                        }}
                                        error={formError?.txn_date}
                                        focus={!!formError?.txn_date}
                                        disabled
                                    />
                                </div>
                                <div className="singleDiv">
                                    <CommonInput
                                        label="Description"
                                        name="description"
                                        value={form?.description}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                        focus={!!formError?.description}
                                        error={formError.description}
                                        disabled
                                    />
                                </div>
                                <div className="singleDiv">
                                    <CommonInput
                                        type="text"
                                        label="Amount (₹)"
                                        placeholder="Amount "
                                        className="__rupeeSymbol"
                                        rupeeSymbol={true}
                                        name="due_amount"
                                        value={form.amount}
                                        maxLength={10}
                                        onChange={({ target: { name, value } }) => {
                                            // if (validateInput(value ? value : 0)) {
                                            if (/^0[0-9]/.test(value)) {
                                                value = value.replace(/^0+/, ''); // "01" → "1"
                                            }

                                            // Allow "0." for decimals but not "0x" where x is digit
                                            if (value === "0") {
                                                handleOnChange(name, value);
                                                return;
                                            }
                                            handleOnChange(name, value);

                                            // }
                                        }}
                                        onKeyDown={handleKeyDown}
                                        focus={!!formError?.due_amount}
                                        error={formError.due_amount}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="_othrExp_recBx">
                            <div className="_clPay_flex">
                                <div className="singleDiv">
                                    <div className="_payMode_hed">
                                        <h4>
                                            Payment Mode
                                        </h4>
                                        {filterList(freigtAccount)?.map((i) => (
                                            <button
                                                className={`_baseSpan ${i?.value == form?.account_sub_category
                                                    ? ""
                                                    : "_bspDisable"
                                                    }`}
                                                disabled={true}
                                                name="account_sub_category"
                                                value={i.value}
                                                onClick={({ target: { name, value } }) => {
                                                    handleOnChange(name, value);
                                                    setAccountType(value);

                                                    if (value == 2) {
                                                        //  venderDetailsFun({ vender_type: 3, vender_id: globTripDetails?.driver_id?._id })
                                                    }
                                                }}

                                            >
                                                {i.label}
                                            </button>
                                        ))}

                                    </div>
                                </div>

                                {form?.account_sub_category == 11 && (
                                    <>


                                        <div className="singleDiv">

                                            <CityDropdownForTrip
                                                label={"Driver"}
                                                placeholder="Select Driver"
                                                fetchData={fetchDriverForVoucher}
                                                pageSize={20}
                                                
                                                selectedItem={form?.vendor_id ? form?.vendor_id : { label: "", value: "" }}
                                                error={!!formError.vendor_id}
                                                errorMessage={formError.vendor_id}
                                                disabled
                                            />
                                        </div>


                                    </>
                                )}

                                {(form?.account_sub_category != 11 && form?.account_sub_category != 1) && (
                                    <>
                                        {!accountLoading ? (
                                            <div className="singleDiv">
                                                <CustomSelect
                                                    label="Select Account"
                                                    name="account_id"
                                                    onSelect={(data) => {
                                                        handleOnChange("account_id", data.value);
                                                    }}
                                                    // value={
                                                    //   form?.account_id
                                                    //     ? accountList?.find(
                                                    //       (i) => i.value == form?.account_id
                                                    //     )
                                                    //     : { label: "", value: "" }
                                                    // }
                                                    value={{ label: detailsProps?.payment_mode?.account?.name, value: detailsProps?.payment_mode?.account?._id }}
                                                    options={accountList}
                                                    focus={!!formError?.account_id}
                                                    error={formError.account_id}
                                                    disabled={true}

                                                />
                                            </div>
                                        ) : (
                                            <SkeletonInput isLoading={accountLoading} />
                                        )}
                                    </>
                                )}

                                {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && (
                                    <div>
                                        <input
                                            type="checkbox"
                                            id="vehicle1"
                                            name="vehicle1"
                                            // value="Bike"
                                            checked={form?.vendor_bank_account ? true : false}
                                            disabled={form?.vendor_bank_account ? true : false}
                                        // onChange={({ target: { name, checked } }) => {
                                        //   setIsCheck(checked);
                                        //   handleOnChange("isCheck", checked);
                                        // }}
                                        />
                                        <label for="vehicle1"> {`Select Bank Account`}</label>
                                        <br />
                                    </div>
                                )}

                                {form?.vendor_bank_account && <div className="singleDiv _bank_details_Make">
                                    {!bankDetails ? <>
                                        {detailsProps?.vendor_bank_account?.ifsc_code && <>
                                            <span>{`Bank - ${detailsProps?.vendor_bank_account?.bank_name
                                                ? `${detailsProps?.vendor_bank_account?.bank_name} `
                                                : ""
                                                } `}</span>
                                            <span>{`A/C Name - ${detailsProps?.vendor_bank_account?.account_name
                                                ? `${detailsProps?.vendor_bank_account?.account_name} `
                                                : ""
                                                } `}</span>
                                            <span>{`A/C No - ${detailsProps?.vendor_bank_account?.account_number
                                                ? `${detailsProps?.vendor_bank_account?.account_number} `
                                                : ""
                                                } `}</span>
                                            <span>
                                                {" "}
                                                {`IFSC - ${detailsProps?.vendor_bank_account?.ifsc_code || ""
                                                    }`}
                                            </span>
                                        </>
                                        }
                                    </> : <>{bankDetails?.ifsc_code && <>
                                        <span>{`Bank - ${bankDetails?.bank_name
                                            ? `${bankDetails?.bank_name} `
                                            : ""
                                            } `}</span>
                                        <span>{`A/C Name - ${bankDetails?.account_name
                                            ? `${bankDetails?.account_name} `
                                            : ""
                                            } `}</span>
                                        <span>{`A/C No - ${bankDetails?.account_number
                                            ? `${bankDetails?.account_number} `
                                            : ""
                                            } `}</span>
                                        <span>
                                            {" "}
                                            {`IFSC - ${bankDetails?.ifsc_code || ""
                                                }`}
                                        </span>
                                    </>
                                    }</>}
                                    {!bankDetails ? <>{detailsProps?.vendor_bank_account?.upi_id && <span>
                                        {" "}
                                        {`UPI ID - ${detailsProps?.vendor_bank_account?.upi_id || ""
                                            }`}
                                    </span>}</> : <>{bankDetails?.upi_id && <span>
                                        {" "}
                                        {`UPI ID - ${bankDetails?.upi_id || ""
                                            }`}
                                    </span>}</>}


                                </div>}
                                <div className="singleDiv">
                                    <CommonInput
                                        label="Transaction Number"
                                        name="transaction_no"
                                        value={form?.transaction_no}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                        focus={!!formError?.transaction_no}
                                        error={formError.transaction_no}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="_othrExp_recBx">
                            <div className="_clPay_flex">
                                <div className="singleDiv">
                                    <div className="_attatchmentBxs">
                                        <div className="__addExp_fileBx">
                                            <h4>Attachment</h4>


                                            <input
                                                type="file"
                                                id="_fileUpload"
                                                onChange={(e) => handleFileChange(e)}
                                                disabled={loading || form?.file?.length >= 5}
                                            />
                                            <label htmlFor="_fileUpload" className="_uploadBtn">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="19"
                                                    viewBox="0 0 20 19"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                                                        fill="#1956F6"
                                                    />
                                                </svg>
                                                <span>{loading ? "Uploadding" : "Add File"}</span>
                                            </label>
                                            {formError?.file && (
                                                <span className="input_drop_error">
                                                    {formError?.file}
                                                </span>
                                            )}
                                        </div>
                                        <div className="img_fnex_src">
                                            {form?.file?.length > 0 &&
                                                form?.file?.map((el, index) => {
                                                    return (
                                                        <>
                                                            <div className="pos-relative">
                                                                <img
                                                                    className="_pdfIcon_sigxe"
                                                                    src={`${masterData?.s3_url}${el?.path}`}
                                                                    alt=""
                                                                />
                                                                <span className="_clDel_icon">
                                                                    <IoCloseCircle
                                                                        onClick={() => documentRemove(index)}
                                                                    />
                                                                </span>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </CommonCanvas>
            {canvasOpen && <BankListCanvas {...bankListProps} />}
            {showAddBank && <AddBankAccount {...firstAddBank} />}
            {accountAddShow && <AddAccountingAccount {...AddTransactionAccountModal} />}
            {payNowAccountCreate && <PayNowAccountNotifyModal {...payNowAccountProps} />}

        </div>
    );
};

export default MakePaymentForExpenseModal;